import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";


const JavaScriptLesson7 = () => {
  const [language, changeLanguage] = useState("javascript");
  const [lineNumbers, toggleLineNumbers] = useState(false);
  const code = (
  'text',
  `
  //Declaration without initialization
  var x;

  //Declaration with initialization
  var x = 4;
  console.log(x);
  `
  );
  const code2 = (
  'text',
  `
  //Declaration without initialization
  var x = 5;

  //Re-declaration
  var x = 9;
  console.log(9);
  `
  );
  const code3 = (
  'text',
  `
  //Declaration without initialization
  var x = 5;

  //Re-assignment
  x = 19;
  console.log(19);
  `
  );
  const code4 = (
  'text',
  `
  //Declaration without initialization
  let x = 5;

  //Re-declaration
  let x = 9; //variable x is already declared
  `
  );
  const code5 = (
  'text',
  `
  //Declaration without initialization
  let x = 5;

  //Re-assignment
  x = 55;
  console.log(55);
  `
  );
  const code6 = (
  'text',
  `
  //Declaration without initialization
  const x = 5;

  //Re-declaration
  const x = 9; //cannot redeclare a const variable
  `
  );
  const code7 = (
  'text',
  `
  //Declaration without initialization
  const x = 5;

  //Re-assignment
  x = 9; //Attempted to assign a read-only property
  `
  );
  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">
    <div className="alert alert-secondary" role="alert">
    <h3><strong>var declaration</strong></h3>
      <p><b>var</b> is a keyword used for variable declaration. we will look at keywords in our next lesson</p>
      <p>Now when we declare a variable, we introducing it on to our programming scene. That is usually the first point of contact, and also we choose to <strong><i>initialize</i></strong> it or just plain declare it.
        <p>When we initialize variables, we assigning it a value. This process is also known as <strong>initialization.</strong></p>
        <p class="mb-4"><b>var</b> is used to declare a variable globally, that is make it accessible to the whole program. It is also changeable.</p>
        <CopyBlock
        language={language}
        text={code}
        showLineNumbers={lineNumbers}
        theme={dracula}
        wrapLines={true}
        codeBlock
        />
        </p>
        <h4><strong>Re-declaration with var &#8212; a potential problem</strong></h4>
          <p><strong>var</strong> allows us to re-declare a variable.</p>
          <p class="mb-2">This could cause potential problems in our application, especially as it begins to scale, and can lead to mis-management of logic.</p>
          <CopyBlock
          language={language}
          text={code2}
          showLineNumbers={lineNumbers}
          theme={dracula}
          wrapLines={true}
          codeBlock
          />
          <p class="mb-4 mt-3">We can also re-assign variables with <strong>var.</strong> When we re-assign variables, we do not use the declaration keyword, we just merely assign the value to a new a value as illustrated below. </p>
          <CopyBlock
          language={language}
          text={code3}
          showLineNumbers={lineNumbers}
          theme={dracula}
          wrapLines={true}
          codeBlock
          />
          </div>

          <div className="alert alert-secondary" role="alert">
          <h3><strong>let</strong> declaration</h3>
          <p><strong>let</strong> is one of the improvements on JavaScript that ES6 brought in 2015</p>
          <p class="mb-4">With <strong>let</strong> we can only re-assign a variable, but we cannot re-declare. This feature ensures that variable names are unique and therefore averts mis-management of logic and potential confusion.</p>
          <CopyBlock
          language={language}
          text={code4}
          showLineNumbers={lineNumbers}
          theme={dracula}
          wrapLines={true}
          codeBlock
          />
          <p class="mb-4 mt-3">We can also do re-assignment with <strong>let</strong>.</p>
          <CopyBlock
          language={language}
          text={code5}
          showLineNumbers={lineNumbers}
          theme={dracula}
          wrapLines={true}
          codeBlock
          />
          </div>
          <div className="alert alert-secondary" role="alert">
           <h3><strong>const</strong> Declaration</h3>
            <p class="mb-4"><strong>const</strong> is also an ES6 improvement. With <strong>const</strong> we cannot re-declare or re-assign.</p>
            <CopyBlock
            language={language}
            text={code6}
            showLineNumbers={lineNumbers}
            theme={dracula}
            wrapLines={true}
            codeBlock
            />
            <div className="mt-3">
            <CopyBlock
            language={language}
            text={code7}
            showLineNumbers={lineNumbers}
            theme={dracula}
            wrapLines={true}
            codeBlock
            />
            </div>
          </div>

    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}

export default JavaScriptLesson7
